// eslint-disable-next-line unused-imports/no-unused-vars
export const blockGQLFields = (fields) => `
  id
  name
  props
  extraProps
  children
  output
`;
//# sourceMappingURL=block.js.map